export const log = (...logs) => {
	const isPDN = process.env.ENVIRONMENT === 'PDN'
	if (isPDN) return

	const sanitizedMessage = sanitizeLogMessage(logs)
	console.log('--------------------')
	console.log(`NOL LOG > ${sanitizedMessage}`)
	console.log('--------------------')
}

function sanitizeLogMessage(logs) {
	const sanitizedEntries = logs.map(entry => {
		if (typeof entry === 'string') {
			return entry.replace(/[^\x20-\x7E]/g, '')
		}
		if (typeof entry === 'object' && entry !== null) {
			try {
				return JSON.stringify(entry).replace(/[^\x20-\x7E]/g, '')
			} catch {
				return '[Object]'
			}
		}
		return String(entry).replace(/[^\x20-\x7E]/g, '')
	})
	return sanitizedEntries.join(' ')
}